import React, { useState, useEffect, useContext, useMemo } from "react";
import Server from "../../Shared/Server";
import Spinner from "../../Shared/Spinner";
import BackButton from "../../Shared/BackButton";
import { FaPrint } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import AuthContext from "../../../context/auth/AuthContext";
import "./ReceiptSytle.css";

const formatNumber = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return '0.00';
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

function Receipt() {
  const [receipt, setReceipt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const currency = user?.branch?.currency || '$'

  useEffect(() => {
    if (location.state){
        const {payload} = location.state
        fetchData(payload)
    } else {
        toast.error("No receipt data provided.");
        navigate(-1);
    }
  }, []);

  const fetchData = async (payload) => {
    setIsLoading(true);
    try {
      const response = await Server.post("/billed/receipt", payload);
      setReceipt(response?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error.response?.status === 401) {
        localStorage.removeItem("user");
        navigate("/login");
      } else {
        toast.error(error.response?.data?.detail || "Error fetching receipt.");
        navigate(-1);
      }
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const grandTotal = useMemo(() => {
    if (!receipt?.voucher_data) return 0;
    return receipt.voucher_data.reduce((sum, item) => sum + parseFloat(item.balance), 0);
  }, [receipt]);

  if (isLoading || !receipt) {
    return <Spinner />;
  }

  const { receipt_number, bill_date, voucher_data, location_data, branch_data } = receipt;

  return (
    <div className="receipt-container">
      <div className="receipt-actions no-print">
        <BackButton to={-1} label="Back" />
        <button className="btn btn-primary" onClick={handlePrint}>
          <FaPrint /> &nbsp;Print
        </button>
      </div>
      <div className="receipt-card">
        <div className="receipt-header">
          <div className="receipt-header-info mt-3">
            <h3>{branch_data.name}</h3>
            <h3>Receipt</h3>
            <p>{branch_data.email} | {branch_data.contacts.join(" / ")}</p>
          </div>
        </div>

        <div className="receipt-details">
          <div className="receipt-number-date">
            <p><strong>Receipt #:</strong> {receipt_number}</p>
            <p><strong>Bill Date:</strong> {bill_date}</p>
          </div>
          <div className="customer-info">
            <p><strong>Customer:</strong> {location_data.full_name}</p>
            <p><strong>Contact:</strong> {location_data.contact_number}</p>
          </div>
        </div>

        <div className="receipt-table-wrapper">
          <table className="receipt-table">
            <thead>
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Summad</th>
                <th>Xuquuq</th>
                <th>Bixin</th>
                <th>Dhimis</th>
                <th>Haraa</th>
              </tr>
            </thead>
            <tbody>
              {voucher_data.length > 0 ? (
                <>
                  {voucher_data.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.location_id}</td>
                      <td>{item.remark}</td>
                      <td>{currency}{formatNumber(item.due)}</td>
                      <td>{currency}{formatNumber(item.paid)}</td>
                      <td>{currency}{formatNumber(item.discount)}</td>
                      <td>{currency}{formatNumber(item.balance)}</td>
                    </tr>
                  ))}
                  <tr className="receipt-total">
                    <td colSpan="6">Haraa Guud</td>
                    <td>{currency}{formatNumber(grandTotal)}</td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center' }}>No receipt data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {branch_data.accounts.length > 0 && (
          <div className="payment-info">
            <h5>PAYMENT ACCOUNTS:</h5>
            {branch_data.accounts.map((account, index) => (
                <p key={index}>{account.name}: {account.number}</p>
            ))}
            <p className="payment-note">
              {branch_data.note}.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Receipt;
